// src/components/footer/sub-components/SubscribeEmail.js
// last update: 6/25/2024

import React, { useState } from "react";
import PropTypes from "prop-types";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import init from "../../../data/setup/init.json";
import { sendSlackMessage } from "../../../hooks/optsApi";

const SubscribeEmail = ({ mailchimpUrl }) => {
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false); // State to manage button disable

  const CustomForm = ({ status, message, onValidated }) => {
    const webSite = init.siteName;
    let email;

    const submit = () => {
      if (isSubmitting) return; // Prevents further clicks if already submitting

      const emailValue = email && email.value;
      if (emailValue && emailValue.indexOf("@") > -1) {
        setStatus("sending");

        const currentDate = new Date();
        const formattedDate = currentDate.toISOString(); // Format the date to ISO string
        const payload = {
          request_date: formattedDate,
          siteName: webSite,
          message: "Please put me on email list",
          EMAIL: emailValue,
          message_status: "new",
        };

        const fetchData = async () => {
          try {
            const data = await sendSlackMessage(payload);
            if (data && data.success) {
              setStatus("success");
              setMessage(data.message);
            } else {
              setStatus("error");
              setMessage("Error sending message to slack");
            }
          } catch (error) {
            setStatus("error");
            setMessage("Error sending message to slack");
          } finally {
            setIsSubmitting(false); // Enable button after submission completes
          }
        };

        fetchData();

        if (onValidated) {
          onValidated({ EMAIL: emailValue });
        }
      } else {
        setStatus("error");
        setMessage("Invalid email address");
      }

      let emailInput = document.getElementById("mc-form-email");
      emailInput.value = "";
    };

    return (
      <div className="subscribe-form-2">
        <div className="mc-form">
          <div>
            <input
              id="mc-form-email"
              className="email"
              ref={(node) => (email = node)}
              type="email"
              placeholder="Enter your email address..."
              style={{ color: "#999", fontSize: "12px" }}
            />
          </div>
          <div className="clear">
            <button className="button" onClick={submit}>
              SUBSCRIBE
            </button>
          </div>
        </div>

        {status === "sending" && (
          <div style={{ color: "#3498db", fontSize: "12px" }}>sending...</div>
        )}
        {status === "error" && (
          <div
            style={{ color: "#e74c3c", fontSize: "12px" }}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        )}
        {status === "success" && (
          <div
            style={{ color: "#2ecc71", fontSize: "12px" }}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        )}
      </div>
    );
  };

  return (
    mailchimpUrl ? (
      <div>
        <MailchimpSubscribe
          url={mailchimpUrl}
          render={({ subscribe, status, message }) => (
            <CustomForm
              status={status}
              message={message}
              onValidated={(formData) => subscribe(formData)}
            />
          )}
        />
      </div>
    ) : (
      <CustomForm
        status={status}
        message={message}
      />
    )
  );
};

SubscribeEmail.propTypes = {
  mailchimpUrl: PropTypes.string,
};

export default SubscribeEmail;

